import { useRouter } from 'next/compat/router';
import usePaths from 'hooks/use-paths';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { setConciergeReferrer } from 'src/concierge/concierge-referrer';
import { writeConciergeMessageSeed } from 'src/concierge/concierge-message-seed-storage';
import type { ConciergeMessageSeed, ConciergeTelemetryEvents } from 'src/concierge/contract/actions';
import { tracker } from 'src/utils/analytics';

type ConciergeEntryLocation = ConciergeTelemetryEvents['conciergeEntryPointClicked']['location'];

export const useConciergeNavigate = (): (() => void) => {
  const router = useRouter();
  const { href } = usePaths();
  const { dispensary } = useDispensary();

  return () => {
    setConciergeReferrer(router?.asPath, dispensary?.id);
    void router?.push(`${href}/concierge`);
  };
};

export const useSeededConciergeNavigate = (): ((
  seed: ConciergeMessageSeed,
  location: ConciergeEntryLocation
) => void) => {
  const { dispensary } = useDispensary();
  const navigate = useConciergeNavigate();

  return (seed, location) => {
    writeConciergeMessageSeed(seed, dispensary?.id);
    tracker.conciergeEntryPointClicked({ location, seeded: true });
    navigate();
  };
};
